export default "__VITE_ASSET__CGhYlgdA__"